import { Injectable } from '@angular/core';

import { AnalyticsService } from '@app/core/analytics.service';
import { FLOW_LOGIN, FLOW_LOGOUT, LOGIN_STARTED } from '@app/core/mixpanel.constants';

@Injectable({
  providedIn: 'root',
})
export class Auth0AnalyticsService extends AnalyticsService {
  trackLoginStarted({ source }: { source?: string } = {}) {
    return this.trackWithDefaultProperties(LOGIN_STARTED, {
      flow: FLOW_LOGIN,
      module: 'Auth0 Redirect',
      source,
    });
  }

  trackLoginCompleted() {
    return this.trackWithDefaultProperties('Login Completed', {
      flow: FLOW_LOGIN,
      module: 'Auth0 Returned',
    });
  }

  trackForcedLogout() {
    return this.trackWithDefaultProperties('Forced Logout', {
      flow: FLOW_LOGOUT,
      module: 'Auth0 Forced Logout',
    });
  }
}
